import axiosHttp from "../../config/axios.interceptor";
import axios from "axios";
import { base_url, httpHeaderConfig } from "../../shared/const.prop";
import { userReducerConstant } from "../reducerConstant";

export const getuserInfo = () => async (dispatch) => {
  try {
    const user = await axiosHttp.get(`profile`);
    dispatch({
      type: userReducerConstant.LOGIN_SUCCESS,
      payload: user?.data?.data || {},
    });
    return user;
  } catch (error) {
    // Re-throw the error so components can handle it
    throw error;
  }
};

export const getFollowersFollowingsCount = () => async (dispatch) => {
  const followersCount = await axiosHttp.get(`follow-count`);
  dispatch({
    type: userReducerConstant.SET_FOLLOWERSFOLLOWINGS_COUNT,
    payload: followersCount?.data?.data || {},
  });
};

export const getFollowersList = () => async (dispatch) => {
  let followers = await axiosHttp.get(`following`);
  // followers = followers.filter(({followerStatus}) => followerStatus === 'R');
  dispatch({
    type: userReducerConstant.GET_FOLLOWERS,
    payload: followers?.data?.data || [],
  });
};

export const getFollowingsList = () => async (dispatch) => {
  const followings = await axiosHttp.get(`following`);
  dispatch({
    type: userReducerConstant.GET_FOLLOWINGS,
    payload: followings?.data?.data || [],
  });
};

export const getFollowerSuggestion = (cat) => async (dispatch) => {
  dispatch({
    type: userReducerConstant.GET_FOLLOWERS_SUGGESTION,
    payload: [],
  });
  try {
    const suggestionList = await axiosHttp.get(
      !cat
        ? "followers-suggestion"
        : `followers-suggestion?skillCategory=${cat}`
    );
    dispatch({
      type: userReducerConstant.GET_FOLLOWERS_SUGGESTION,
      payload: suggestionList?.data?.data || [],
    });
  } catch (error) {
    dispatch({
      type: userReducerConstant.GET_FOLLOWERS_SUGGESTION,
      payload: [],
    });
  }
};

export const getUserActivity = (userId) => (dispatch) => {
  if (!(userId && dispatch)) return;
  axiosHttp
    .get("users/" + userId + "/activity")
    .then((userActivity) => {
      dispatch({
        type: userReducerConstant.SET_USER_ACTIVITY_COUNT,
        payload: userActivity?.data?.data,
      });
    })
    .catch((error) => {
      //console.error(error?.response?.data?.message);
    });
};

const formatLanguagesForAPI = (languages) => {
  if (languages && languages.length > 0) {
    return languages.map(({ language_id }) => language_id);
  } else {
    return [];
  }
};

const formatEducationsForAPI = (userEducations) => {
  let education = [];
  if (userEducations && userEducations?.length > 0) {
    education = userEducations.map(
      ({
        institution_name,
        institution_type,
        institution_department,
        start_year,
        end_year,
      }) => {
        return {
          name: institution_name || "",
          type: institution_type || "",
          className: institution_department || "",
          startYear: start_year || "",
          endYear: end_year || "",
        };
      }
    );
  }
  return education;
};

const formatExperienceForAPI = (userExperiences) => {
  let experience = [];
  if (userExperiences && userExperiences?.length > 0) {
    experience = userExperiences.map(
      ({ company_name, position, experiance }) => {
        return {
          companyName: company_name || "",
          position: position || "",
          experience: experiance || "",
        };
      }
    );
  }
  return experience;
};

// Skills & Interest & Experties
const formatOtherDataForAPI = (input) => {
  let output = [];
  if (input && input?.length > 0) {
    output = input.map(({ value }) => {
      return {
        value: value || "",
      };
    });
  }
  return output;
};

const formatUserDataForAPI = ({ userData, countries, states }) => {
  // let country = "";
  // let state = "";

  // if (countries && countries?.length > 0 && userData?.address?.countryName) {
  //   const userCountryInfo = countries.filter((item) => {
  //     return item.id === userData?.address?.countryName;
  //   });
  //   if (userCountryInfo?.length > 0) {
  //     country = userCountryInfo[0]?.name || "";
  //   }
  // }
  // if (states && states?.length > 0 && userData?.address?.stateName) {
  //   const userStateInfo = states.filter((item) => {
  //     return item.id === userData?.address?.stateName;
  //   });
  //   if (userStateInfo?.length > 0) {
  //     state = userStateInfo[0]?.name || "";
  //   }
  // }

  return {
    firstName: userData?.fName || "",
    lastName: userData?.lName || "",
    dob: userData?.dob || "",
    gender: userData?.gender || "",
    countryCode: userData?.countryCode || "",
    phoneNumber: userData?.phone || "",
    whatsappNumber: userData?.whatsapp || "",
    link: userData?.link || "",
    about: userData?.about || "",
    experiences: userData?.experiences || "",
    address: {
      country: userData?.address?.countryId || "",
      state: userData?.address?.stateId || "",
      city: userData?.address?.city || "",
    },
    experienceType: userData?.experienceType || "",
    offerService: userData?.offerService || false,
    languages: formatLanguagesForAPI(userData?.userLanguages) || [],
    education: formatEducationsForAPI(userData?.userEducations) || [],
    experience: formatExperienceForAPI(userData?.userExperiances) || [],
    skills: formatOtherDataForAPI(userData?.skills) || [],
    interest: formatOtherDataForAPI(userData?.interest) || [],
    experties: formatOtherDataForAPI(userData?.experties) || [],
  };
};

export const updateProfile = (
  updatedData,
  successCallback,
  failureCallback
) => {
  return async (dispatch, getState) => {
    const { user, utilData } = getState();
    if (
      user?.userData &&
      Object.keys(user?.userData).length > 0 &&
      updatedData
    ) {
      const requestBody = {
        ...formatUserDataForAPI({
          userData: user?.userData,
          countries: utilData?.countryList || [],
          states: utilData?.stateList || [],
        }),
        ...updatedData,
      };
      try {
        const updateResponse = await axiosHttp.post("profile", requestBody);
        if (
          updateResponse &&
          updateResponse?.status === 201 &&
          successCallback
        ) {
          successCallback();
        }
      } catch (err) {
        if (failureCallback) {
          failureCallback(err);
        }
      }
    }
  };
};

export const updateProfileImage = (
  updatedData,
  successCallback,
  failureCallback,
  ext = ""
) => {
  return async (dispatch, getState) => {
    if (updatedData && Object.keys(updatedData).length > 0) {
      let objectKey = "";
      if (updatedData["profile-picture"]) {
        objectKey = "profile-picture";
      } else {
        objectKey = "banner-picture";
      }
      try {
        const imageResponse = await axios.post(
          base_url + "upload-image",
          updatedData[objectKey],
          {
            headers: {
              ...httpHeaderConfig,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (imageResponse?.data) {
          const updateResponse = await axiosHttp.post(objectKey, {
            url: imageResponse?.data?.tempPath + ext,
          });
          if (
            updateResponse &&
            updateResponse?.status === 201 &&
            successCallback
          ) {
            successCallback();
          }
        }
      } catch (err) {
        if (failureCallback) {
          failureCallback(err);
        }
      }
    }
  };
};

export const getImagesFromPosts = () => async (dispatch) => {
  const imageResponse = await axiosHttp.get("post-data?type=image");
  dispatch({
    type: userReducerConstant.SET_IMAGE_POSTS,
    payload: imageResponse?.data || {},
  });
};

export const getReels = () => async (dispatch) => {
  const reelsResponse = await axiosHttp.get(
    "following-user-posts?page=1&type=reels"
  );
  dispatch({
    type: userReducerConstant.GET_REELS,
    payload: reelsResponse?.data?.data,
  });
};
